import { Clock } from 'lucide-react';
import MarkdownContent from '@/components/ui/MarkdownContent';

interface AnnouncementBannerProps {
	text: string;
}

const AnnouncementBanner = ({ text }: AnnouncementBannerProps) => {
	return (
		<div className="bg-[#DC2626] text-white py-2 text-sm font-medium" data-nosnippet>
			<div className="flex items-center justify-center gap-2 px-4">
				<Clock className="size-4 shrink-0" />
				<MarkdownContent content={text} inline />
			</div>
		</div>
	);
};

export default AnnouncementBanner;
